import { data as areaList } from './components/search-tab/map-config.js'

const INFO = {
  hospital: {
    name: '医院',
    desc: '医院STEM介绍医院STEM介绍医院STEM介绍医院STEM介绍医院STEM介绍医院STEM介绍医院STEM介绍'
  },
  college: {
    name: '医学院校',
    desc: '医学院校STEM介绍医院STEM介绍医院STEM介绍医院STEM介绍医院STEM介绍医院STEM介绍医院STEM介绍'
  }
}

//默认学科
export const DEFAULT_SUBJECT = ['其他', '32021']

//学科
export const SUBJECT_OPTIONS = [
  {
    value: '内科学',
    label: '内科学',
    children: [
      { label: '麻醉学', value: '麻醉学' },
      { label: '心血管病学', value: '心血管病学' },
      { label: '呼吸病学', value: '呼吸病学' },
      { label: '结核病学', value: '结核病学' },
      { label: '消化病学', value: '消化病学' },
      { label: '血液病学', value: '血液病学' },
      { label: '肾脏病学', value: '肾脏病学' },
      { label: '内分泌病学与代谢病学', value: '内分泌病学与代谢病学' },
      { label: '风湿病学与自体免疫病学', value: '风湿病学与自体免疫病学' },
      { label: '变态反应学', value: '变态反应学' },
      { label: '传染病学', value: '传染病学' },
      { label: '普通外科学', value: '普通外科学' },
      { label: '神经外科学', value: '神经外科学' },
      { label: '胸外科学', value: '胸外科学' },
      { label: '心血管外科学', value: '心血管外科学' },
      { label: '泌尿外科学', value: '泌尿外科学' },
      { label: '骨外科学', value: '骨外科学' },
      { label: '烧伤外科学', value: '烧伤外科学' },
      { label: '整形外科学', value: '整形外科学' },
      { label: '妇产科学', value: '妇产科学' },
      { label: '儿科学', value: '儿科学' },
      { label: '眼科学', value: '眼科学' },
      { label: '耳鼻咽喉科学', value: '耳鼻咽喉科学' },
      { label: '口腔医院', value: '口腔医院' },
      { label: '皮肤病学', value: '皮肤病学' },
      { label: '神经病学', value: '神经病学' },
      { label: '精神病学', value: '精神病学' },
      { label: '重症医学', value: '重症医学' },
      { label: '急诊医学', value: '急诊医学' },
      { label: '肿瘤学', value: '肿瘤学' },
      { label: '护理学', value: '护理学' }
    ]
  }
  // { name: '综合', value: '综合' },
]

//省市
export const AREA_OPTIONS = [
  {
    name: '全国',
    value: 'all'
  },
  ...areaList
]

export default INFO
